import { useGetAncillaryById } from "./useGetAncillaryById";
import { useGetMovieById } from "./useGetMovieById";
import { useGetTvSeriesById } from "./useGetTvSeriesById";

export const useContentApi = () => {
    const { getMovieById } = useGetMovieById();
    const { getTvSeriesById } = useGetTvSeriesById();
    const { getAncillaryById } = useGetAncillaryById();

    return {
        getMovieById,
        getTvSeriesById,
        getAncillaryById
    };
};
